import _errorHandler from './errorHandler';
import _debounce from './debounce';
import _formats from './formats';
import _helper from './helper';
import _sso from './singleSignOn';

export const arrayToObject = function arrayToObject(objItem, array) {
  return array.reduce((arg1, item) => {
    const obj = arg1 || {};
    obj[item.value] = objItem[item.value];
    return obj;
  }, {});
};

export const mixin = {
  methods: {
    arrayToObject,
  },
};

export const errorHandler = _errorHandler;
export const debounce = _debounce;
export const formats = _formats;
export const helper = _helper;
export const sso = _sso;
